export default __webpack_public_path__ + "static/media/img-0113-canada-half-face.9c0f3678.png";